import React from 'react';
import { useIdioma } from '../../i18n/idioma';
import { X, ArrowRight } from 'lucide-react';
import { Button } from '../ui/Button';

interface PricingNextStepModalProps {
  open: boolean;
  unpricedCount: number;
  nextItemLabel?: string;
  pendingLabel?: string;
  onShowNext: () => void;
  onContinueAnyway: () => void;
  onClose: () => void;
}

const PricingNextStepModal: React.FC<PricingNextStepModalProps> = ({
  open,
  unpricedCount,
  nextItemLabel,
  pendingLabel,
  onShowNext,
  onContinueAnyway,
  onClose,
}) => {
    const { t } = useIdioma();
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-end sm:items-center justify-center p-4">
      <button
        type="button"
        aria-label={t('comun.cerrar')}
        className="absolute inset-0 bg-navy-950/50"
        onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
      />
      <div className="relative w-full max-w-md bg-white rounded-3xl shadow-s3 overflow-hidden animate-in slide-in-from-bottom-4 sm:zoom-in-95">
        <div className="px-5 pt-5 pb-4">
          <div className="flex items-start justify-between gap-3">
            <div>
              <p className="label-ui">
                {t('estimados.precios.modal.tip')}
              </p>
              <h3 className="font-semibold tracking-tight text-navy-950 text-lg mt-1">
                {t('estimados.precios.modal.titulo')}
              </h3>
            </div>
            <button
              type="button"
              onClick={onClose}
aria-label={t('estimados.precios.modal.cerrar')}
              className="p-1.5 text-peligro hover:bg-peligro-bg rounded-lg transition-colors duration-150 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-400"
            >
              <X size={16} />
            </button>
          </div>

          <p className="text-sm text-acero-600 mt-3 leading-relaxed">
            {t('estimados.precios.modal.texto_inicio')} <span className="font-data tabular-nums text-navy-950">{unpricedCount}</span>
            {unpricedCount === 1 ? t('estimados.precios.modal.costo_singular') : t('estimados.precios.modal.costo_plural')}{t('estimados.precios.modal.texto_fin')}
            {' '}
            {t('estimados.precios.modal.texto_explicacion')}
          </p>

          {nextItemLabel && (
            <p className="mt-2 text-xs text-acero-500">
              {t('estimados.precios.modal.sigue')} <span className="font-medium text-navy-950">{nextItemLabel}</span>
            </p>
          )}

          {pendingLabel && (
            <p className="mt-3 px-3 py-2 bg-acero-50 border border-acero-200 rounded-xl text-xs text-acero-500">
              {t('estimados.precios.modal.pendiente')} <span className="font-medium text-navy-950">{pendingLabel}</span>
            </p>
          )}
        </div>

        <div className="px-5 pb-5 flex flex-col gap-2">
          <Button variant="secondary" className="w-full" onClick={onShowNext} rightIcon={<ArrowRight size={16} />}>
            {t('estimados.precios.modal.boton_siguiente')}
          </Button>
          <Button variant="ghost" className="w-full" onClick={onContinueAnyway}>
            {t('estimados.precios.modal.boton_continuar')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PricingNextStepModal;
